// extracted by mini-css-extract-plugin
export default {"logo":"FolderHeader_logo__Rw49Y","subtitle":"FolderHeader_subtitle__18qYY"};